import { render } from "./Buttons.vue?vue&type=template&id=3d36760d"
import script from "./Buttons.vue?vue&type=script&lang=js"
export * from "./Buttons.vue?vue&type=script&lang=js"

import exportComponent from "/builds/conurse/admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__